import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NewWatcherQueryParams } from '../../../watchers/watchers.types';
import { Chips } from '../../../components/chips/Chips';
import { Highlight } from '../../../components/highlight/Highlight';
import {
  ModalScrollableContent,
  ModalScrollableFooter,
  ModalScrollableHeader,
  ModalScrollableContainer,
  ModalScrollableBody,
} from '../../../components/modal/index';
import { getQueryAndKeywordsWords } from './searchDecisionWatcherUtils';
import { WatcherCreationForm } from './form/WatcherCreationForm';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
  queryParams: NewWatcherQueryParams;
  tags: string[];
  onCreate: () => void;
};

type State = {
  error: boolean;
  isLoading: boolean;
};

export class AddWatcherModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = {
    error: false,
    isLoading: false,
  };

  validateWatcherCreation = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { closeModal, onCreate } = this.props;
    this.setState({ isLoading: true });
    try {
      await onCreate();
      this.setState({ isLoading: false });
      closeModal();
    } catch (error) {
      this.setState({ isLoading: false, error: true });
      throw error;
    }
  };

  /* eslint-disable react/no-array-index-key */
  render() {
    const { closeModal, tags, queryParams, isOpen } = this.props;
    const { error, isLoading } = this.state;

    const queryAndKeywordsArray = getQueryAndKeywordsWords(queryParams);

    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={closeModal}>
        <ModalScrollableHeader title="Créer une alerte" onClose={closeModal} />
        <ModalScrollableContent>
          <ModalScrollableBody>
            <div className="add-watcher-modal__content">
              <div className="add-watcher-modal__info">
                <FormattedMessage id="search/components/search-decision-watcher/AddWatcherModal.tsx/1" />
              </div>
              <div className="add-watcher-modal__item">
                <div className="add-watcher-modal__subtitle">
                  <FormattedMessage id="search/components/search-decision-watcher/AddWatcherModal.tsx/2" />
                </div>
                <ul>
                  {queryAndKeywordsArray.map((words, wordsIndex) => (
                    <li key={`word-${wordsIndex}`}>
                      <div className="add-watcher-modal__keyword">
                        {words.map((word, wordIndex) => (
                          <span
                            key={`word-${wordsIndex}-${wordIndex}`}
                            className="add-watcher-modal_word"
                          >
                            <Highlight>{word}</Highlight>{' '}
                          </span>
                        ))}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              {tags.length > 0 && (
                <div className="add-watcher-modal__item">
                  <div className="add-watcher-modal__subtitle">
                    {tags.length}
                    {tags.length > 1
                      ? ' filtres additionnels'
                      : ' filtre additionnel'}
                  </div>
                  <ul>
                    {tags.map((tag, tagIndex) => (
                      <li
                        className="add-watcher-modal__filter"
                        key={`tag-${tagIndex}`}
                      >
                        <Chips color="secondary">{tag}</Chips>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {error && (
                <div className="add-watcher-modal__error">
                  <FormattedMessage id="search/components/search-decision-watcher/AddWatcherModal.tsx/3" />
                </div>
              )}
            </div>
          </ModalScrollableBody>
        </ModalScrollableContent>
        <ModalScrollableFooter>
          <WatcherCreationForm
            cancelButton={{ callback: closeModal }}
            validateButton={{
              callback: this.validateWatcherCreation,
              isLoading,
            }}
          />
        </ModalScrollableFooter>
      </ModalScrollableContainer>
    );
  }
}
